import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";
import { stat } from "fs";

class actionPlanDataAccess {
  deleteQuestionaryInfo = (ids: number | number[]) => {
    if (Array.isArray(ids)) {
      return commonDataAccess.postData("Questionary/deleteAll", ids);
    } else {
      return commonDataAccess.deleteData(`Questionary/delete/${ids}`);
    }
  }

  getSupplierActionPlanList = async (params: {
    pageNo;
    pageSize;
    sortData;
    status: string; 
    filters: Array<IFilter>;
  }) => {
    let _filters = {};
    console.log(params.filters);
    params.filters.forEach((item) => {
      if (item.value && item.value.length > 0) {
        _filters["filter." + item.propertyName] = item.value + "-" + item.type;
      }
    });
    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      status: params.status,
      ..._filters,
    };
    return await commonDataAccess.getData(
      "ActionPlan/getActionPlan",
      parameters
    );
  };


  getActionPlanById = async (params: { id: number | bigint }) => {
    var result = await commonDataAccess.getData(
      "ActionPlan/getActionPlanById/" + params,
      {}
    );
    return result;
  };
  saveActionPlan = (data: any) => {
    return commonDataAccess.postData("ActionPlan/save/actionPlan", data);
  };

  deleteActionPlan = (ids: number | number[]) => {
    if (Array.isArray(ids)) {
      return commonDataAccess.postData("ActionPlan/deleteAll", ids);
    } else {
      return commonDataAccess.deleteData(`ActionPlan/delete/${ids}`);
    }
  }

  getSupplierActionPlan(supplierId: number) {
    return commonDataAccess.getData("ActionPlan/get/supplier-actionPlan", {
      supplierId: supplierId,
    });
  }


  saveActionPlanProcesses(payload: any, actionPlanId: any, processType: string) {
    return commonDataAccess.postData(
      "ActionPlan/save/actionPlanProcesses",
      payload,
      {
        actionPlanId: actionPlanId,
        processType: processType,
      }
    );
  }
  getActionPlanProcesses(actionPlanId: any, processType: string) {
    return commonDataAccess.getData(
      "ActionPlan/get/actionPlanProcesses",
      {
        actionPlanId: actionPlanId,
        processType: processType,
      }
    );
  }

  getActionPlanCounts = () => {
    return commonDataAccess.getData("ActionPlan/getActionPlanCounts");
  };
}

export default new actionPlanDataAccess();
